// Confidence bands per the study-units design reference.
//
// Bands are FIXED at 30/60 (per the design fixes spec) — independent of
// the user-configurable thRed/thGreen used elsewhere in the app via
// confColor(). This is intentional for the study-unit visuals and the
// detail panel: the design reference uses literal hex values that map
// to fixed percentage bands.
//
// 0-30%  → red    #ef4444
// 31-60% → amber  #f59e0b
// 61-100% → green #10b981
// no data → grey  #aaa

export const BAND_RED = '#ef4444';
export const BAND_AMBER = '#f59e0b';
export const BAND_GREEN = '#10b981';
export const BAND_GREY = '#aaa';

export const BADGE_BG = {
  weak:        '#fee2e2',
  'needs-work':'#fef3c7',
  strong:      '#d1fae5',
  none:        '#f0ede6',
};
export const BADGE_TEXT = {
  weak:        '#991b1b',
  'needs-work':'#92400e',
  strong:      '#065f46',
  none:        '#aaa',
};

// Provider icons for the External scores section
export const PROVIDER_COLOR = {
  BARBRI:    '#6366f1',
  'Law Drills':'#0ea5e9',
  'SQETrack':'#3B82F6',
};
export const PROVIDER_INITIAL = {
  BARBRI:    'B',
  'Law Drills':'LD',
  'SQETrack':'ST',
};

// Map a 0-1 confidence value (or null) to its band hex colour.
export function bandHex(value) {
  if (value === null || value === undefined) return BAND_GREY;
  const pct = value * 100;
  if (pct <= 30) return BAND_RED;
  if (pct <= 60) return BAND_AMBER;
  return BAND_GREEN;
}

// Map a 0-1 confidence value (or null) to a band key.
export function bandKey(value) {
  if (value === null || value === undefined) return 'none';
  const pct = value * 100;
  if (pct <= 30) return 'weak';
  if (pct <= 60) return 'needs-work';
  return 'strong';
}

// Unified vocabulary across filter chips, status pills, and badges:
//   red band (0-30)  → "Needs work"
//   amber band (31-60) → "Needs work"  (same label; chip colour differs)
//   green band (61-100) → "Strong"
//   null → "Not started"
export const BAND_LABEL = {
  weak:        'Needs work',
  'needs-work':'Needs work',
  strong:      'Strong',
  none:        'Not started',
};
